<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qSxbuc/tc-custom/9781504082372.jpg?1738328776700" alt="This image is the cover for the book Obsessed"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Obsessed
      </h1>
      <p class="bookDescription body article font2">
        <b>How do you hunt a monster when you can’t remember his face? The author of <i>Her Dark Past</i> returns with a new novel of trauma, terror and missing memories . . .</b><br/>  <br/> Lisa walks in the woods on a regular basis. But this time when she emerges, she is badly injured. Her wedding ring is missing. And her memory of the event is blank.<br/>  <br/> Unsettled, she tells her husband that she was mugged by a young girl but insists he not call the police. It doesn’t take long for fragments of the truth to come back, though, and when Lisa realises that she was assaulted by a man and left to die, she begins to live in fear, seeing threats everywhere she looks. What if he comes back for her—and she doesn’t even recognise him? Even co-workers and neighbours could be suspects . . .<br/>  <br/> Soon, Lisa discovers she is not the only victim and becomes fixated on pursuing the perpetrator. But is she really prepared for the horrifying truth she is about to discover?<br/><br/><b>Content Warning: This book deals with themes of abuse and sexual assault.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jane Heafield
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ef7955a8